<template>
	<div class="">
		<!-- terminalDevice组件 添加终端设备 -->
		
		<!--添加终端设备弹框-->
		<el-form ref="addDev" :model="addDev">
			<el-form-item label="产品类型" :label-width="formLabelWidth">
				<el-select class="" @change="clickType()" v-model="selectId" placeholder="请选择类别">
					<el-option v-for="type in types" :label="type.mount_name" :key="type.id" :value="type.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="产品名称" :label-width="formLabelWidth">
				<el-select class="" v-model="product_id" placeholder="请选择">
					<el-option v-for="adaDev in adaptiveDevices" :label="adaDev.product_name" :key="adaDev.id" :value="adaDev.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="名称" :label-width="formLabelWidth">
				<el-input v-model="devName" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="通讯地址" :label-width="formLabelWidth" prop="postalAaddress">
				<el-input v-model="addDev.postalAaddress" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="备注" :label-width="formLabelWidth">
				<el-input v-model="remarks" auto-complete="off"></el-input>
			</el-form-item>
			<br />
			<el-form-item class="text-right">
				<el-button @click="childCancel">取 消</el-button>
				<!-- 网关添加终端 -->
				<el-button type="primary" v-if="!ifAddModel" @click="addTerminal()">确 定</el-button>
				<!-- 模板添加终端 -->
				<el-button type="primary" v-if="ifAddModel" @click="addModelTerminal()">确 定</el-button>
			</el-form-item>
		</el-form>
	
	</div>
</template>

<script>
	export default {
		mounted() {
			this.getTypes();
		},
		props:['ifAddModel'],
    	data(){
    		return{
    			formLabelWidth:"90px",
    			types:[],
    			selectId:null,
    			adaptiveDevices:[],
    			administrators:this.getCookie('administrators'),
    			remarks:"",
    			addDev:{
    				postalAaddress:null,
    			},
				devName:"",
				product_id:null,
    		}
    	},
    	methods:{
			//获取终端类别
    		getTypes(){
    			//获取类别列表
    			let valiCodeParams={
					uid:this.getCookie('uid'),
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/MountManage/MountShow",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		this.types = res.data.data || [];
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
    		},
    		//点击类别
    		clickType(){
    			//点击类别获取类别下适配设备列表
    			let valiCodeParams={
					uid:this.getCookie('uid'),
					type:this.selectId,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/RsproductManage/RsproductType",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		this.adaptiveDevices = res.data.data || [];
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
			// 子传父通讯
			childCancel(){
				this.$emit('childByValue', false)
			},
			// 初始化表单数据
			initData(){
				this.selectId = null;
				this.product_id = null;
				this.remarks = "";
				this.devName = "";
				this.postalAaddress = "";
			},
			//网关添加终端设备
    		addTerminal(){
    			let valiCodeParams={
					uid:this.getCookie('uid'),
					device_id:this.$route.query.id,
					mount_id: this.selectId,
					product_id:this.product_id,
					name: this.devName,
					postal_address: this.addDev.postalAaddress || 0,
					remarks: this.remarks,
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
				};
				this.sign2(valiCodeParams);
				this.$ajax.post(this.$store.state.domain2+"/admin/MountDetailManage/AddMountDetail",this.$qs.stringify(valiCodeParams),{
					emulateJSON: true
				}).then(res=>{
					if(res.data.code==200 & res.data.data!=null){
						this.childCancel();
						this.$message.success(res.data.msg);
						this.initData();
						
						
					}else if(res.data.code==10008){
						this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
					}else{
						//console.log(res.data.msg);
						this.$message.error(res.data.msg);
					}
				});
    				
			},
			// 模板添加终端
			addModelTerminal(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					template_id:this.$route.query.id,
					product_id:this.product_id,
					mount_id: this.selectId,					
					name: this.devName,
					postal_address: this.addDev.postalAaddress || 0,
					remarks: this.remarks,
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
				};
				this.sign2(valiCodeParams);
				this.$ajax.post(this.$store.state.domain2+"/admin/TemplateManage/AddTemplateDetail",this.$qs.stringify(valiCodeParams),{
					emulateJSON: true
				}).then(res=>{
					if(res.data.code==200 & res.data.data!=null){
						this.childCancel();
						this.$message.success(res.data.msg);
						this.initData();
						
					}else if(res.data.code==10008){
						this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
					}else{
						//console.log(res.data.msg);
						this.$message.error(res.data.msg);
					}
				});
			}
    	
    	}
   }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/comss/addTerminal.vue